/**
 * Get the current timestamp
 * @returns {number} - the timestamp since epoch in milliseconds
*/
export function getTimestamp() {
  return Date.now();
}
